import React, { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import { api, BRAND, formatApiError } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Common";
import { toast } from "sonner";
import { computePaymentDisplayStatus, STATUS_LABEL, STATUS_CHIP } from "@/lib/whatsapp";

export default function MyFinance() {
  const { user } = useAuth();
  const [pays, setPays] = useState([]);

  useEffect(() => {
    if (!user?.student_id) return;
    api.get(`/payments/student/${user.student_id}`).then(r => setPays(r.data))
      .catch(err => toast.error(formatApiError(err)));
  }, [user]);

  return (
    <div data-testid="student-finance-page">
      <PageHeader eyebrow="Mensalidades" title="Meu financeiro" subtitle="Vencimento todo dia 10 do mês." mascot={BRAND.MANGUITA_TOQUE} />
      {pays.length === 0 ? (
        <EmptyState title="Sem registros financeiros" description="Assim que o administrador registrar sua mensalidade, ela aparecerá aqui." mascot={BRAND.MANGUITO} />
      ) : (
        <div className="vv-card">
          <div className="p-4 border-b border-border font-black uppercase tracking-wider text-sm">Histórico</div>
          <div className="divide-y divide-border">
            {pays.map((p) => {
              const ds = computePaymentDisplayStatus({ status: p.status, month: p.month });
              return (
                <div key={p.id} className="p-4 flex items-center justify-between" data-testid={`my-finance-row-${p.id}`}>
                  <div>
                    <div className="font-black text-lg">{p.month}</div>
                    {p.amount && <div className="text-sm text-muted-foreground">R$ {Number(p.amount).toFixed(2)}</div>}
                    {p.notes && <div className="text-xs text-muted-foreground mt-1">{p.notes}</div>}
                  </div>
                  <span className={`vv-chip ${STATUS_CHIP[ds]}`}>{STATUS_LABEL[ds]}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
